import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api';
import { LocalizationSettings } from 'src/app/shared/localization/localization.service';
import { IPaginatedResponse } from 'src/app/shared/models';
import { ICustomCaseListColumn, ICustomCaseSearchResult } from '../../reports-models';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TableModule } from 'primeng/table';

@Component({
  selector: 'app-custom-case-list',
  templateUrl: './custom-case-list.component.html',
  styleUrls: ['./custom-case-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule, TableModule,]
})

export class CustomCaseListComponent {

  @Input()
  columns: ICustomCaseListColumn[];
  @Input()
  paginatedList: IPaginatedResponse<ICustomCaseSearchResult>;
  @Input()
  numberOfItemsPerPage: number;
  @Input()
  pageNumber: number;

  @Input()
  localizationSettings: LocalizationSettings;
  @Input()
  isLoading: boolean;

  @Output()
  selectedPageNumber = new EventEmitter<number>();
  @Output()
  numberOfItemsPerPageChange = new EventEmitter<number>();
  @Output()
  onExportExcelClick = new EventEmitter();

  @Output()
  selectedCase = new EventEmitter<ICustomCaseSearchResult>();

  get first(): number {
    return ((this.pageNumber ?? 1)  - 1) * this.numberOfItemsPerPage;
  }

  onPageChange(event: LazyLoadEvent) {
    if (event.rows != this.numberOfItemsPerPage) {this.numberOfItemsPerPageChange.emit(event.rows); }

    const selectedPage = (event.first == 0) ? 1 : (event.first / event.rows + 1);
    this.selectedPageNumber.emit(selectedPage);
  }

  onSelected(caseModel: ICustomCaseSearchResult) {
    this.selectedCase.emit(caseModel);
  }

  getStringList(value: string): string[] | null {
    if (!value) return null;
    const list = value.split(',').map(x => x.trim()).filter(x => x.length > 0);
    return list.length ? list : null;
  }

  tryGetDate(dateString: string): Date | null {
    if (!dateString) return null;
    const date = new Date(dateString);
    return isNaN(date.getTime()) ? null : date;
  }
}
